/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

$(function () {
  $(document).scroll(function () {
    var $nav = $(".site-header__wrapper");
    $nav.toggleClass('scrolled', $(this).scrollTop() > $nav.height());
  });
});

// this is very crowded but is works.. revisit later

$("#tab-desc").click(function(){
  if($("#tab-mat, #content-mat").hasClass("is-active")) {
    $("#tab-mat, #content-mat").toggleClass("is-active");
    $("#tab-desc, #content-desc").toggleClass("is-active");
  } else if ($("#tab-rev, #content-rev").hasClass("is-active")){
    $("#tab-desc, #content-desc").toggleClass("is-active");
    $("#tab-rev, #content-rev").toggleClass("is-active");
  } 
});

$("#tab-mat").click(function(){

  if ($("#tab-rev, #content-rev").hasClass("is-active")) {
    $("#tab-rev, #content-rev").toggleClass("is-active");
    $("#tab-mat, #content-mat").toggleClass("is-active");
  } else if ($("#tab-desc, #content-desc").hasClass("is-active")) {
    $("#tab-desc, #content-desc").toggleClass("is-active");
    $("#tab-mat, #content-mat").toggleClass("is-active");
  }
});

$("#tab-rev").click(function(){

  if ($("#tab-mat, #content-mat").hasClass("is-active")) {
    $("#tab-mat, #content-mat").toggleClass("is-active");
    $("#tab-rev, #content-rev").toggleClass("is-active");
  } else if ($("#tab-desc, #content-desc").hasClass("is-active")) {
    $("#tab-desc, #content-desc").toggleClass("is-active");
    $("#tab-rev, #content-rev").toggleClass("is-active");

  }
});



$('.thumbnail-img').click(function(){
	console.log($(this).attr("data-for-main"))
    $('#main-product-img').attr('src', $(this).attr("data-for-main"))
})
